module.exports = __webpack_public_path__ + "Sheppard56.jpg?286acea4cb6b03c9049ea41d3c3a2a65";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/Sheppard56.jpg
// module id = 550
// module chunks = 0